import useDims from "./useDims";
import { checkIsPC } from "../atoms";

const useCheckPC = () => {
  const { width } = useDims({ height: 0, width: window.innerWidth });
  return checkIsPC(width);
};

export default useCheckPC;
